import { render, staticRenderFns } from "./ForgotPassAdmin.vue?vue&type=template&id=4b6207b6&scoped=true"
import script from "./ForgotPassAdmin.vue?vue&type=script&lang=js"
export * from "./ForgotPassAdmin.vue?vue&type=script&lang=js"
import style0 from "./ForgotPassAdmin.vue?vue&type=style&index=0&id=4b6207b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6207b6",
  null
  
)

export default component.exports